<template>
  <div class="content">
    <el-card style="width:100%;text-align:left;margin-top: 16px;">
      <div class="recent">我的</div>
      <div>
        <el-form label-position="top" label-width="100px" :model="profileForm">
          <el-form-item label="账户">
            <el-input v-model="user.email" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="profileForm.name" placeholder="填写您的姓名"><el-button @click="saveName" slot="append" icon="el-icon-check"></el-button></el-input>
          </el-form-item>
          <el-form-item label="更改密码">
            <el-button type="primary" @click="resetPassword">发送更改密码邮件</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Profile',
  props: ['user'],
  data () {
    return {
      profileForm: {
        name: this.user.displayName
      }
    }
  },
  methods: {
    saveName: function () {
      let user = firebase.auth().currentUser
      let name = this.profileForm.name
      let that = this
      user.updateProfile({
        displayName: name
      }).then(() => {
        that.$message({
          message: '更新成功！',
          center: true,
          type: 'success'
        })
      })
    },
    resetPassword: function () {
      let auth = firebase.auth()
      let user = auth.currentUser
      let that = this
      auth.sendPasswordResetEmail(user.email).then(function () {
        // Email sent.
        that.$message({
          message: `已发送邮件至 ${user.email}`,
          center: true,
          type: 'success'
        })
      }).catch(function (err) {
        // An error happened.
        that.$message({
          message: `发送邮件至 ${user.email} 失败, 请重试`,
          center: true,
          type: 'error'
        })
        // console.log(err)
      })
    }
  }
}
</script>

<style>
.content {
  width: 60%;
  margin: auto;
}
.recent {
  font-family: Montserrat, sans-serif;
  margin-top: 8px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 812px) {
  .content {
    width: 100%;
    margin: auto;
  }
}
</style>
